import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { fleetEnvironment } from './fleet-environment';
import { mapsetSettingsSchema } from './schemas/map-set-settings.schema';

export function getMapSetSettings() {
  return fromFetch(
    new Request(fleetEnvironment.companyMapsetSettingsUrl, {
      method: 'GET',
      headers: {
        ...requiredHeaders,
        ...new FleetJwtAuthHeaders(),
      },
    })
  ).pipe(selectData(mapsetSettingsSchema));
}
